<template>
  <div class="zan-wrap">
    <div class="zan-icon" @click="changeValue">
      <i v-if="!value" class="inactive iconfont" :class="iconsClassCopy[0]"></i>
      <i v-else class="active iconfont" :class="iconsClassCopy[1]"></i>
    </div>
    <div class="zan-value" v-show="showNumber">{{number}}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    showNumber: {
      type: Boolean,
      default: false,
    },
    number: {
      type: [Number, String],
      default: 0,
    },
    // 点赞图标的颜色
    size: {
      type: [Number, String],
      default: 30,
    },
    iconClass: {
      type: [Array, String],
      default: ['icon-weidianzan', 'icon-dianzan'],
    },
    inactiveColor: {
      type: String,
      default: '#979797',
    },
    activeColor: {
      type: String,
      default: '#f50',
    },
    textColor: {
      type: String,
      default: '#aaa',
    },
  },
  emits: ['change'],
  data() {
    return {
      fontSize: 30,
      iconsClassCopy: [],
    }
  },
  mounted() {
    this.fontSize = this.ratio * this.size + 'px'
    if (typeof this.iconClass == 'string') {
      this.iconsClassCopy = [this.iconClass, this.iconClass]
    } else {
      if (Object.prototype.toString.apply(this.iconClass) == '[object Array]') {
        if (this.iconClass.length > 1) {
          this.iconsClassCopy = [this.iconClass[0], this.iconClass[1]]
        } else {
          this.iconsClassCopy = [this.iconClass[0], this.iconClass[0]]
        }
      } else {
        this.iconsClassCopy = ['icon-dianzan', 'icon-weidianzan']
      }
    }
  },
  methods: {
    changeValue() {
      this.$emit('change', !this.value)
    },
  },
}
</script>

<style scoped>
.zan-wrap {
  display: inline-block;
  justify-content: space-around;
  font-size: 0;
}
.zan-icon{
  display: inline-block;
}
.zan-icon i {
  font-size: v-bind(fontSize);
}
.inactive {
  color: v-bind(inactiveColor);
}
.active {
  color: v-bind(activeColor);
}
.zan-value {
  display: inline-block;
  padding-left: 12px;
  color: v-bind(textColor);
  font-size: 24px;
}
</style>